export default __webpack_public_path__ + "static/media/MerchantMarket.34453c02.png";